var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_1367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0682 11.1968C14.9368 11.503 14.7444 11.7792 14.5028 12.0086L8.99996 17.3571L3.4971 12.0086C3.25552 11.7792 3.06314 11.503 2.93168 11.1968C2.80022 10.8907 2.73242 10.561 2.73242 10.2279C2.73242 9.89469 2.80022 9.56501 2.93168 9.25888C3.06314 8.95275 3.25552 8.67656 3.4971 8.44714C3.99164 7.97778 4.64744 7.71612 5.32925 7.71612C6.01105 7.71612 6.66686 7.97778 7.16139 8.44714L8.99996 10.2857L10.8385 8.44714C11.3331 7.97778 11.9889 7.71612 12.6707 7.71612C13.3525 7.71612 14.0083 7.97778 14.5028 8.44714C14.7444 8.67656 14.9368 8.95275 15.0682 9.25888C15.1997 9.56501 15.2675 9.89469 15.2675 10.2279C15.2675 10.561 15.1997 10.8907 15.0682 11.1968Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8182 5.03256C10.336 5.5148 9.68195 5.78571 8.99996 5.78571C8.31798 5.78571 7.66392 5.5148 7.18169 5.03256C6.69945 4.55032 6.42853 3.89627 6.42853 3.21429C6.42853 2.5323 6.69945 1.87825 7.18169 1.39601C7.66392 0.913774 8.31798 0.642857 8.99996 0.642857C9.68195 0.642857 10.336 0.913774 10.8182 1.39601C11.3005 1.87825 11.5714 2.5323 11.5714 3.21429C11.5714 3.89627 11.3005 4.55032 10.8182 5.03256Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_1367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerHealth);
export default __webpack_public_path__ + "static/media/customerHealth.7f7ab1d3848cbe8c861bd0a72acbe4e6.svg";
export { ForwardRef as ReactComponent };